export default __webpack_public_path__ + "dist/media/RejectedRed.56188233.svg";